import {
  CalendarOutlined,
  MessageOutlined,
  RightOutlined
} from '@ant-design/icons';
import { IProfessorAreaForum } from 'interfaces/professor_area/forums';
import { Space, Typography } from 'antd';
import { SyntheticEvent } from 'react';
import { formatDate } from 'services/date';
import { useNavigation } from '@refinedev/core';

type ForumsItemProps = IProfessorAreaForum & {
  canShow: boolean;
  classroomId?: string;
};

export const ForumsItem = ({
  canShow,
  classroomId,
  ...forum
}: ForumsItemProps) => {
  const { push } = useNavigation();

  const handleNavigate = (e: SyntheticEvent<HTMLDivElement>): void => {
    e?.preventDefault();

    if (!canShow || !classroomId) {
      return;
    }

    push(`/professor_area/classrooms/${classroomId}/forums/show/${forum.id}`);
  };

  return (
    <Space
      size="small"
      className={`group w-full p-4 justify-between transition ${
        canShow
          ? 'hover:cursor-pointer hover:bg-neutral-100 hover:rounded-lg'
          : ''
      }`}
      onClick={canShow ? handleNavigate : undefined}
    >
      <Space direction="vertical" className="!gap-0">
        <Typography.Text className="!text-md">{forum.title}</Typography.Text>

        <Space className="gap-4">
          <Typography.Text type="secondary">
            {forum.author_type === 'User'
              ? forum.author.full_name_or_name
              : forum.author.name}
          </Typography.Text>

          <Space className="gap-1">
            <MessageOutlined />
            <Typography.Text type="secondary">
              {forum.posts_count ?? 0}
            </Typography.Text>
          </Space>

          <Space className="gap-1">
            <CalendarOutlined />
            <Typography.Text type="secondary">
              {formatDate(forum.created_at, 'DD/MM/YYYY')}
            </Typography.Text>
          </Space>
        </Space>
      </Space>

      {canShow && (
        <RightOutlined className="opacity-0 group-hover:opacity-100 transition" />
      )}
    </Space>
  );
};
